interface CustomContainerProps {
  children: React.ReactNode;
  borderColor?: string;
  borderWidth?: string;
  backgroundColor?: string;
  padding?: string;
  margin?: string;
  borderRadius?: string;
  className?: string;
}
type ContainerProps = CustomContainerProps & React.HTMLAttributes<HTMLDivElement>;

export const Container = ({
  children,
  borderColor = '',
  borderWidth = '',
  backgroundColor = '',
  padding = '',
  margin = '',
  borderRadius = '',
  className = '',
  ...props
}:ContainerProps) => {
  const containerClass = `${borderColor} ${borderWidth} ${backgroundColor} ${padding} ${margin} ${borderRadius} ${className}`;

  return <div className={containerClass} {...props}>{children}</div>;
};

